import React, { useEffect, useState, useRef } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import NavBarLeft from '../../ReusableComp/NavBarLeft';
import InputComponent from './../../ReusableComp/InputComponent';
import PMSAddEvent from '../PMS_Event_Bank/PMSAddEvent';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useDispatch, useSelector } from 'react-redux';
import { allAeBankEvents, getAEPreview, saveNewStudy, getDoseAdministration, getSiteAdministration } from '../../../Redux/actions/actions';
import { EVENT_CLASSIFICATION_AESI, EVENT_CLASSIFICATION_GRADE_CTCAE, EVENT_CLASSIFICATION_LEVEL_BRIGHTON, base_url } from '../../../utilities';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import moment from 'moment';
import Loader from '../../ReusableComp/Loader';
import axios from '../../../axios-interceptor';
import PopUpModal from '../../ReusableComp/PopUpModal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
 



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius:'7px',
    boxShadow: 24,
    // p: 4,   
    pt:0  
  };

const PMSNewStudySetup = () => {
    const dispatch = useDispatch();
    const aePreviewData = useSelector((state) => (state.allAEPreview));
    const createStudy = useSelector((state) => (state.createStudy));
    const [loading, setLoading] = useState(false);

    const [saveAlert, setSaveAlert] = useState(false)

    useEffect(() => {
       
        setLoading(true)
        dispatch(getAEPreview())
        if (createStudy?.i_success === true) {
            getStudyCreateStatus()
        }
        setLoading(false)
    }, [dispatch, createStudy])
    const getStudyCreateStatus = () => {
        // setLoading(true)
        setSaveAlert(true)
       
        // setTimeout(() => {
        //     setLoading(false)
          
        //     }, 2000)

    }
   
    return (
        <div>
            <NavigationBar  studyDropdwn={true} title={'Study Creation'}/>
            <div className='main_body adverse_event_main'>
                <FourPageComponent saveAlert={saveAlert} getStudyCreateStatus={getStudyCreateStatus} aePreviewData={aePreviewData} />
            </div>

        </div>
    );
};

export default PMSNewStudySetup;

const LeftSideComponent = ({ currentPage, getTitle }) => {
    
    
    const handleClick = (data) => {
    };

    const myArray = [
        {
            id: 1, title: "1. Study Details", description: 'Name, Doses, Subjects, etc.'
        },
        {
            id: 2, title: "2. Adverse Events", description: 'Cold, Fever, Levels/Grades etc.'
        },
        {
            id: 3, title: "3. Adverse Event of Special Interest", description: 'Adverse Events of Special Interest'
        },
        {
            id: 4, title: "4. Preview and Confirm", description: 'Final confirmation'
        },
    ]
    const title = myArray.find((item) => item.id === currentPage)?.title;

    useEffect(() => {
        getTitle(title)

    }, [title])
    return (

        <div className='left_content_study_setup'>
            {myArray.map((data, index) => {
                return (
                    <div
                        key={index}
                        className={`${currentPage === index + 1 ? "selectedTabStyl" : ""
                            }`}
                    >
                        <div
                            key={index}
                            className=''
                            style={{ marginLeft: "4px" }}
                            onClick={() => handleClick(data)}
                        >
                            <div className={currentPage === index + 1 ? 'studytab_active' : 'studytab'}>
                                <span className='text-start'>{data.title}</span>
                                <span className="study_tab_desc">{data.description}</span>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>

    );
};


const FourPageComponent = ({ aePreviewData, getStudyCreateStatus, saveAlert }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [getPageTitle, setGetPageTitle] = useState('');
    const [fileName, setFileName] = useState('')
    const dispatch = useDispatch();
    const doseAdministration = useSelector((state) => (state.doseAdministration));
    const siteAdministration = useSelector((state) => (state.siteAdministration));
    const [selectedDoseAdmin, setSelectedDoseAdmin] = useState("");
    const [selectedSiteAdmin, setSelectedSiteAdmin] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [saveAlertAdverse,setSaveAlertAdverse]=useState(false);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [ageGroupValue,setAgeGroupValue] =useState("")
    const [error, setError] = useState('');
    const getTitle = (props) => {
        setGetPageTitle(props)
    }
    const ageGroupFocus = () => {
        const start = inputValues.age_group.split('-');
        if(start.length != 2){
            setError('Age range is invalid ex:10-60');
            setInputValues((prevValues) => ({
                ...prevValues,
                age_group: '',
                
            }));
        }
        else if (parseInt( start[0]) > parseInt(start[1])) {
            setInputValues((prevValues) => ({
                            ...prevValues,
                            age_group: '',
                            
                        }));
            setError('Age range is invalid');
        } else {
            setError(''); 
        }
    };

  

    const handleNextPage = () => {
        
        
        
        if (studyDoc == "" || studyDoc == undefined) {
            toast.error("Please Upload a Thumbnail Image", {
                toastId: 7,
            });
        }
        else {
            setCurrentPage((prevPage) => prevPage < 4 ? prevPage + 1 : prevPage);
        }
    };

    const handlePreviousPage = () => {
        
        setCurrentPage((prevPage) => prevPage > 1 ? prevPage - 1 : prevPage);
    };
    const navigate = useNavigate();
    const handleSaveStudy =async () => {
        setIsLoading(true);
     const fd = new FormData();
     for (const key in myObject) {  
    if (key === 'duration_between_doses' && (myObject[key])=='') {
        myObject[key]=0;
    }
    if (key === 'array_of_aebanks') {
           fd.append(key, JSON.stringify(myObject[key]));
    } else {
           fd.append(key, myObject[key]);
    }
   }
   fd.append('file', studyDoc);
       axios
         .post(base_url + "study/create_new_study", fd, {
           headers: {
               'Content-Type': 'multipart/form-data'
           }
       })
         .then((response) => {
            setIsLoading(false);
            if(response.data.data.errors[0].message=="study_name must be unique"){
                toast.error('The study has already been created with this study name. Please try using a different name.', {
                    toastId: 15
                  })
            }else{
                toast.error('Error occured while creating the study', {
                    toastId: 19
                  })
            }
         })
         .catch((error) => {
            setisDoneDisble(true)
            setOpen(true)
         }); 
    
    }
    const handleClosePopup = () => {
        navigate("/pmsstudydetails")
        window.location.reload();
    };
    const viewProfile = () => {
        navigate("/pmsstudydetails")
        window.location.reload();
    }
    const [checkedVals, setCheckedVals] = useState([])
    const [listOfAESI, setListOfAESI] = useState([])
    const consolidatedFinalAeArray = [...listOfAESI, ...checkedVals]
    const [inputValues, setInputValues] = useState({
        study_name: '',
        protocol_number: '',
        version: '',
        protocol_effective_date: '',
        date_of_approval: '',
        approval_number: '',
        indication: '',
        number_of_doses: '',
        estimated_subjects: '',
        medical_emergency_contact: '',
        product_name: '',
        // study_duration_from: '',
        // study_duration_to: null,
        duration_between_doses: '',
        duration_between_doses_type: 'days',
        estimated_sites: '',
        age_group: '',
        study_initiation_date: '',
        dose_of_administration: '',
        immediate_adverse_event: "",
        active_follow_up: "",
        safety_follow_up: "",
        anatomical_site_administration: "",
        spoc:"",
    });

    const myObject = {
        ...inputValues,
        array_of_aebanks: consolidatedFinalAeArray
    };
    const tableTitles = [
        'Study Name',
        'Protocol Number',
        'Version',
        'Protocol Effective Date',
        'Date of Approval',
        'Approval Number',
        'Indication',
        'Doses',
        'Subjects',
        'Medical Emergency Contact',
        
    ]

    const mappedValues = tableTitles.map((title, index) => {
        return {
            title: title,
            value:
                (title == 'Date of Approval' || title == 'Protocol Effective Date') ? moment(inputValues[Object.keys(inputValues)[index]]).format("DD-MM-YYYY") :
                    inputValues[Object.keys(inputValues)[index]]
        };
    });



//     const isBtnEnabled = Object.keys(inputValues)
//   .filter((i) => i !== 'study_duration_to')
//   .map((key) => inputValues[key])
//   .every((value) => value !== '' && value !== null);

//         const isAllFieldsFilled=()=>{
//             if(inputValues.study_name!=="" &&  inputValues.product_name!=="" && inputValues.number_of_doses!=="" &&
//                 inputValues.anatomical_site_administration!=="" && inputValues.indication!=="" && inputValues.duration_between_doses!=="" &&
//                 inputValues.age_group!=="" && inputValues.estimated_subjects!=="" && inputValues.estimated_sites!=="" &&
//                 inputValues.protocol_number!=="" && inputValues.version!=="" && inputValues.protocol_effective_date!=="" &&
//                 inputValues.approval_number!=="" && inputValues.immediate_adverse_event!=="" && inputValues.active_follow_up!=="" &&
//                 inputValues.safety_follow_up!=="" && inputValues.medical_emergency_contact!==""){
//                     return true;
//                 }
//             else{
//                 return false;
//             }
//         }
const isBtnEnabled = () => {
    // Create a list of fields that should be validated unconditionally
    const fieldsToValidateUnconditionally = [
      'study_name', 'product_name', 'number_of_doses', 'anatomical_site_administration',
      'indication', 'age_group', 'estimated_subjects', 'estimated_sites', 'protocol_number',
      'version', 'protocol_effective_date', 'approval_number', 'immediate_adverse_event',
      'active_follow_up', 'safety_follow_up', 'medical_emergency_contact','spoc'
    ];
  
    // Validate fields that should be validated unconditionally
    const isUnconditionallyValid = fieldsToValidateUnconditionally.every(key => {
      return inputValues[key] !== '' && inputValues[key] !== null;
    });
  
    // Validate 'duration_between_doses' conditionally if 'number_of_doses' is greater than 1
    const isDurationValid = (inputValues.number_of_doses > 1) ?
      inputValues.duration_between_doses !== '' :
      true;
  
    // Return true if all conditions are met, otherwise return false
    return isUnconditionallyValid && isDurationValid && fileName !== '';
  };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const regex = /^.*$/;
        const regex1 = /^[A-Za-z0-9]+$/;
        const regex2 = /[A-Za-z]+$/;
        // const regex3 = /^[0-9-\d\-\/]*$/;
        const regex3 = /^[0-9]+(-[0-9]*)?$/;
        const regex4 = /^[1-9]\d*$/;
       
        if (name === "indication") {
            if (regex.test(value) || value === '') {

                setInputValues((prevValues) => ({
                    ...prevValues,
                    [name]: value,
                }));
            }
        }

        else if ((name === "number_of_doses") ||(name === "duration_between_doses" ) || (name === "estimated_sites" ) || (name === "estimated_subjects" )  || (name === "immediate_adverse_event" ) || (name === "active_follow_up" ) || (name === "safety_follow_up" ) ) {
            if (regex4.test(value) || value === '') {
              setInputValues((prevValues) => ({
                ...prevValues,
                [name]: value,
              }));
              if(name === "number_of_doses"){
                if(value === '1'){
                    setInputValues((prevValues) => ({
                        ...prevValues,
                        ["duration_between_doses"]: '',
                      }));
                }
              }
            }

          }
          
        else if (name === "age_group") {
            setAgeGroupValue(value)
                if (regex3.test(value) || value === '') {
                    setError("")
                    setInputValues((prevValues) => ({
                        ...prevValues,
                        [name]: value,
                    }));
                               
                    }                 
                                
        }
        else if (name === "approval_number") {


            setInputValues((prevValues) => ({
                ...prevValues,
                [name]: value,
            }));

        }
        else if (name === "dose_of_administration") {
            const selectedIndex = e.target.selectedIndex;
            if (selectedIndex !== 0) {
                setSelectedDoseAdmin(e.target.value)
                setInputValues((prevValues) => ({
                    ...prevValues,
                    [name]: doseAdministration[selectedIndex - 1].dose_administration_id,
                }));
            }
            else {
                setSelectedDoseAdmin("")
                setInputValues((prevValues) => ({
                    ...prevValues,
                    [name]: "",
                }));
            }
        }
        else if (name === "anatomical_site_administration") {
            const selectedIndex = e.target.selectedIndex;
            if (selectedIndex !== 0) {
                setSelectedSiteAdmin(e.target.value)
                setInputValues((prevValues) => ({
                    ...prevValues,
                    [name]: siteAdministration[selectedIndex - 1].anatomical_site_administration_id,
                }));
            }
            else {
                setSelectedSiteAdmin("")
                setInputValues((prevValues) => ({
                    ...prevValues,
                    [name]: "",
                }));
            }
        }
        else {
            if(name === "protocol_effective_date"){
                
                
                    setInputValues((prevValues) => ({
                        ...prevValues,
                        ["date_of_approval"]: "",
                        ["study_initiation_date"]: ""

                    }));
                
            }
            if(name === "date_of_approval"){
                
                    setInputValues((prevValues) => ({
                        ...prevValues,
                        ["study_initiation_date"]: ""

                    }));
                
            }
            setInputValues((prevValues) => ({
                ...prevValues,
                [name]: value,
            }));
        }
        
       


    };

    const [studyDoc, setstudyDoc] = useState("");
    const [diable, setisDoneDisble] = useState(false);
    const handleUploadFile = (event) => {
        if ((event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".jpg") ||
            (event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".jpeg") ||
            (event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".png") ||
            (event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.')) == ".bmp")) {
           
            if (event.target.files[0].size < 20971520) {
                if (event.target.files[0].name) {
                    setFileName(event.target.files[0].name)
                }
                setstudyDoc(event.target.files[0]);
            } else {
                toast.error("File size should be less than 20 MB", {
                    toastId: 7,
                });
            }
        }
        else {
            toast.error("Please upload a valid images .png / .jpeg / .jpg", {
                toastId: 7,
                className: 'custom-toast',
            });
        }
    }
    const clearUploadedFile = () => {
        setFileName('');
        setstudyDoc(null);
            // Clear the input field by setting its value to an empty string
        const inputField = document.getElementById('thumbnailimageUpload');
        if (inputField) {
        inputField.value = '';
        }
      }
      const handlePreview = () => {
        // Add logic here to open the uploaded document in the browser preview
        // For example, you can use window.open() to open a new tab with the document URL
        // Make sure to handle different file types (e.g., PDF, image, etc.) accordingly
        if (studyDoc) {
          // Sample logic for PDF preview
          window.open(URL.createObjectURL(studyDoc), '_blank');
        }
    }
    const allAdvEvents = useSelector((state) => (state.allAeEventsData));

    const isBtnTwoEnabled = checkedVals.length === 0

    const handleCheckBox = (e, check) => {
        const { checked } = e.target;
        if (checked) {
            setCheckedVals(pre => [...pre, check])
        } else {
            
            setCheckedVals(prev => prev.filter(item => item.aebank_id !== check.aebank_id));
            

        }
    }



    const listAesiBtn = listOfAESI.length === 0

    const handleRadioBtn = (e, check) => {
        setListOfAESI([check])
        dispatch(getAEPreview(check.aebank_id))

    }
    const confirmAdverse=()=>{
        setSaveAlertAdverse(false);
        dispatch(allAeBankEvents());
        setIsLoading(true);
        // setToggle(true);
    }

    useEffect(() => {
        dispatch(allAeBankEvents());
        dispatch(getDoseAdministration())
        dispatch(getSiteAdministration())
    }, [dispatch])
    useEffect(() => {    
        if(allAdvEvents){
            setIsLoading(false);
          }
    }, [allAdvEvents]);

    const [toggle, setToggle] = useState(false)
    const durtnOptions = [{ option: "Days" }, { option: "Weeks" }, { option: "Months" },]

    const handleToggleBtn = () => {
        if (!toggle) { setToggle(true) }
        else (setToggle(false))
        setListOfAESI([])
        if (!toggle) {
            dispatch(getAEPreview(null))
        }
    };
    function handleStudyCreation() {
        navigate('/pmsstudydetails')
        setTimeout(() => {
            window.location.reload()
        }, 100);
    }

    const handleOpen = () => setModalOpen(true);
    const handleClose = (event,reason) => 
    {
        if (reason !== 'backdropClick') {
            setModalOpen(false);
          }    
    }
    const handleCloseSave=(event,reason)=>{
        if (reason !== 'backdropClick') {
            setSaveAlertAdverse(false);
          }    
    }

    

    return (
        <>
        <div>
            <div className="row  ">
                <div className="col-lg-4 left_content_main" style={{ width: "360px", backgroundColor: "#E2E8F0" }}>
                    <div className='lableSteps regstep_title'><span>New Study Setup</span></div>

                    <LeftSideComponent
                        currentPage={currentPage}
                        getTitle={getTitle}
                    />

                </div>


                <div className="col d-flex flex-column ">

                    <div className="labletxt"><span>{getPageTitle}</span><span>{currentPage} of 4</span></div>
                    {currentPage === 2 &&
                        <div className="labletxt" style={{backgroundColor:"white"}}>
                                <h5 className="col pt-1">Select Adverse Criteria</h5>
                                 <button className="col-3 AE_gray_btn p-1" style={{fontSize:"16px"}} onClick={handleOpen}>
                                + New Adverse Event
                                </button>
                            </div>
                    }
                    <div >
                        {currentPage === 1 &&

                            <div className="subject_reg_body gap-1 pb-4">


                                <div className="row">
                                    <div className="col">
                                        <InputComponent
                                            label={'Study Name'}
                                            name={'study_name'}
                                            id={''}
                                            value={inputValues.study_name}
                                            required={'*'}
                                            type="text"
                                            placeholder={"Enter study name"}
                                            disabled={false}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col">
                                        <InputComponent
                                            required={'*'}
                                            label={'Product Name'}
                                            name={'product_name'}
                                            value={inputValues.product_name}
                                            id={''}
                                            type="text"
                                            placeholder={"Enter product  name"}
                                            disabled={false}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <InputComponent
                                            label={'Number of Doses'}
                                            required={'*'}
                                            name={'number_of_doses'}
                                            value={inputValues.number_of_doses}
                                            id={''}
                                            type="number"
                                            placeholder={"Input no.of doses"}
                                            disabled={false}
                                            onChange={handleInputChange}
                                            min="0"
                                        />
                                    </div>
                                    <div className="col mt-2 selectdivstyl" >

                                        <label htmlFor="dose_admin" className="select-label">Dose Administration<span className='text-danger'>*</span></label>
                                        <select className="custom-select" name="dose_of_administration" id="dose_admin" value={selectedDoseAdmin} onChange={handleInputChange} style={{ width: "380px" }}>
                                            <option>Select</option>
                                            {doseAdministration && doseAdministration.map((dose) =>
                                                <option value={dose.dose_administration_name}>{dose.dose_administration_name}</option>
                                            )}
                                        </select>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="site_admin" className="select-label">Anatomical Site of Administration<span className='text-danger'>*</span></label>
                                        <select className="custom-select" name="anatomical_site_administration" id="site_admin" value={selectedSiteAdmin} onChange={handleInputChange} style={{ width: "380px" }}>
                                            <option>Select</option>
                                            {siteAdministration && siteAdministration.map((dose) =>
                                                <option value={dose.anatomical_site_administration_name}>{dose.anatomical_site_administration_name}</option>
                                            )}
                                        </select>
                                    </div>
                                    <div className="col">

                                    </div>
                                </div>
                                <div className="row">
                                    <InputComponent
                                        name='indication'
                                        label={"Indication"}
                                        divclass={'mt-3'}
                                        value={inputValues.indication}
                                        placeholder={'Indication Details'}
                                        width={'800px'}
                                        id={''}
                                        required={"*"}
                                        type='text'
                                        disabled={false}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="row">
                                    <div className='row'>
                                        <div className="col mt-2">

                                            <Form.Label className='text-left d-flex mb-0 select-label'>
                                                Duration between Doses<span className='text-danger'>{inputValues.number_of_doses > 1 ? "*" : null}</span>
                                            </Form.Label>

                                            {inputValues.number_of_doses > 1 ? (
                                                <InputGroup className='' style={{ width: "380px" }}>
                                                    <Form.Control
                                                    className='bs_input_group'
                                                    onChange={handleInputChange}
                                                    value={inputValues.duration_between_doses}
                                                    type="number"
                                                    name="duration_between_doses"
                                                    placeholder=""
                                                    aria-label="Input group example"
                                                    aria-describedby="btnGroupAddon"
                                                    min="0"
                                                    />
                                                    <InputGroup.Text id="btnGroupAddon" className='bg-white asdasdsadasd'>
                                                    <select
                                                        className="custom-select-group"
                                                        name='duration_between_doses_type'
                                                        value={inputValues.duration_between_doses_type}
                                                        onChange={handleInputChange}
                                                    >
                                                        {durtnOptions && durtnOptions.map((dur) =>
                                                        <option value={dur.option}>{dur.option}</option>
                                                        )}
                                                    </select>
                                                    </InputGroup.Text>
                                                </InputGroup>
                                                ) : (
                                                // Render something else (e.g., a disabled input group)
                                                    <InputGroup disabled className='' style={{ width: "380px" }}>
                                                    <Form.Control
                                                    disabled
                                                    className='bs_input_group'
                                                    onChange={handleInputChange}
                                                    value={inputValues.duration_between_doses}
                                                    type="number"
                                                    name="duration_between_doses"
                                                    placeholder=""
                                                    aria-label="Input group example"
                                                    aria-describedby="btnGroupAddon"
                                                    min="0"
                                                    />
                                                    <InputGroup.Text id="btnGroupAddon" className='bg-white asdasdsadasd'>
                                                    <select
                                                        className="custom-select-group"
                                                        name='duration_between_doses_type'
                                                        value={inputValues.duration_between_doses_type}
                                                        onChange={handleInputChange}
                                                        disabled
                                                    >
                                                        {durtnOptions && durtnOptions.map((dur) =>
                                                        <option value={dur.option}>{dur.option}</option>
                                                        )}
                                                    </select>
                                                    </InputGroup.Text>
                                                    
                                                </InputGroup>
                                                
                                                )}

                                        </div>
                                        <div className="col" >
                                            <InputComponent
                                                label={'Age Group'}
                                                required={'*'}
                                                name={'age_group'}
                                                value={inputValues.age_group}
                                                id={''}
                                                type="text"
                                                placeholder={"18-60"}
                                                disabled={false}
                                                onChange={handleInputChange}
                                                onBlur={ageGroupFocus}
                                                autoFocus={error?true:false}
                                            />
                                              {error && <div className="text-danger "  >{error}</div>}
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col">

                                            <InputComponent
                                                label={'Estimated Subjects'}
                                                required={'*'}
                                                value={inputValues.estimated_subjects}
                                                name={'estimated_subjects'}
                                                id={''}
                                                type="number"
                                                placeholder={"No.of subjects"}
                                                disabled={false}
                                                onChange={handleInputChange}
                                                min="0"
                                            />

                                        </div>
                                        <div className="col">
                                            <InputComponent
                                                label={'Estimated Sites'}
                                                required={'*'}
                                                name={'estimated_sites'}
                                                value={inputValues.estimated_sites}
                                                id={''}
                                                type="number"
                                                placeholder={"Est no.of sites"}
                                                disabled={false}
                                                onChange={handleInputChange}
                                                min="0"
                                            />
                                        </div>

                                    </div>


                                    <div className="row">

                                        <div className="row">
                                            <div className="col">
                                                <InputComponent
                                                    label={'Protocol Number'}
                                                    required={'*'}
                                                    name={'protocol_number'}
                                                    value={inputValues.protocol_number}
                                                    id={''}
                                                    type="text"
                                                    placeholder={"Enter protocol number"}
                                                    disabled={false}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="col">
                                                <InputComponent
                                                    label={'Version'}
                                                    required={'*'}
                                                    name={'version'}
                                                    value={inputValues.version}
                                                    id={''}
                                                    type="text"
                                                    placeholder={""}
                                                    disabled={false}
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                        </div>
                                        <div className="row ">
                                            <div className="col ">
                                                <label htmlFor="protocol_effective_date" className="custm_label_fw">
                                                Protocol Effective Date<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    required={'*'}
                                                    name={'protocol_effective_date'}
                                                    value={inputValues.protocol_effective_date}
                                                    id={''}
                                                    type="date"
                                                    placeholder={""}
                                                    disabled={false}
                                                    onChange={handleInputChange}
                                                    style={{ padding: "16px 12px", width: "380px", cursor: "not-allowed" }}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                            <div className="col">
                                            <label htmlFor="date_of_approval" className="custm_label_fw">
                                            Date of Approval<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    label={'Date of Approval'}
                                                    value={inputValues.date_of_approval}
                                                    required={'*'}
                                                    name={'date_of_approval'}
                                                    id={''}
                                                    type="date"
                                                    placeholder={""}
                                                    min={inputValues.protocol_effective_date || ''}
                                                    disabled={!inputValues.protocol_effective_date}
                                                    onChange={handleInputChange}
                                                    style={{ padding: "16px 12px", width: "380px", cursor: "not-allowed" }}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>

                                        </div>
                                        <div className="row mt-2">
                                            <div className="col mt-2">
                                            <label htmlFor="study_initiation_date" className="custm_label_fw">
                                            Study Initiation Date<span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    required={'*'}
                                                    name={'study_initiation_date'}
                                                    value={inputValues.study_initiation_date}
                                                    id={''}
                                                    type="date"
                                                    placeholder={""}
                                                    min={inputValues.date_of_approval || ''}
                                                    disabled={!inputValues.date_of_approval}
                                                    onChange={handleInputChange}
                                                    style={{ padding: "16px 12px", width: "380px", cursor: "not-allowed" }}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                            <div className="col ">
                                                <InputComponent
                                                    label={'Approval Number'}
                                                    required={'*'}
                                                    name={'approval_number'}
                                                    value={inputValues.approval_number}
                                                    id={''}
                                                    type="text"
                                                    placeholder={"Enter approval number"}
                                                    // value={''}
                                                    disabled={false}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <Form.Label className='text-left d-flex mb-0 select-label'>
                                                    Immediate Adverse Event<span className='text-danger'>*</span>

                                                </Form.Label>
                                                <InputGroup style={{ width: "380px" }} >

                                                    <Form.Control
                                                        className='bs_input_group'
                                                        onChange={handleInputChange}
                                                        value={inputValues.immediate_adverse_event}
                                                        type="number"
                                                        name="immediate_adverse_event"
                                                        placeholder=""
                                                        aria-label="Input group example"
                                                        aria-describedby="btnGroupAddon"
                                                        min="0"
                                                    />
                                                    <InputGroup.Text id="btnGroupAddon" className='bg-white asdasdsadasd'>

                                                        <span className="" name="Immediate Adverse Event">Mins</span>

                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                            <div className="col">
                                                <Form.Label className='text-left d-flex mb-0 select-label'>
                                                    Active Follow-up<span className='text-danger'>*</span>

                                                </Form.Label>
                                                <InputGroup style={{ width: "380px" }}>

                                                    <Form.Control
                                                        className='bs_input_group'
                                                        onChange={handleInputChange}
                                                        value={inputValues.active_follow_up}
                                                        type="number"
                                                        name="active_follow_up"
                                                        placeholder=""
                                                        aria-label="Input group example"
                                                        aria-describedby="btnGroupAddon"
                                                        min="0"
                                                    />
                                                    <InputGroup.Text id="btnGroupAddon" className='bg-white asdasdsadasd'>

                                                        <span className="" name="Immediate Adverse Event">Days</span>

                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <Form.Label className='text-left d-flex mb-0 select-label'>
                                                    Safety Follow-up<span className='text-danger'>*</span>

                                                </Form.Label>
                                                <InputGroup style={{ width: "380px" }}>
                                                    <Form.Control
                                                        className='bs_input_group'
                                                        onChange={handleInputChange}
                                                        value={inputValues.safety_follow_up}
                                                        type="number"
                                                        name="safety_follow_up"
                                                        placeholder=""
                                                        aria-label="Input group example"
                                                        aria-describedby="btnGroupAddon"
                                                        min="0"
                                                    />
                                                    <InputGroup.Text id="btnGroupAddon" className='bg-white asdasdsadasd'>

                                                        <span className="" name="Immediate Adverse Event">Days</span>

                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                            <div className="col">
                                           
                                                <InputComponent
                                                    label={'Spoc'}
                                                    required={'*'}
                                                    name={'spoc'}
                                                    value={inputValues.spoc}
                                                    id={''}
                                                    type="text"
                                                    placeholder={"Enter spoc"}
                                                    // value={''}
                                                    disabled={false}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mt-4">
                                            <div className="col">
                                                <InputComponent
                                                    label={'Medical Emergency Contact'}
                                                    required={'*'}
                                                    name={'medical_emergency_contact'}
                                                    value={inputValues.medical_emergency_contact}
                                                    id={''}
                                                    type="text"
                                                    placeholder={"Please enter medical monitoring details"}
                                                    width={'800px'}
                                                    disabled={false}
                                                    onChange={handleInputChange}
                                                />

                                            </div>
                                        </div>


                                    </div>
                                    {/* <div className="row" >
                                        <div className='studysetup  piDetilsItems col-4 '>
                                            <label htmlFor="" className=' '>Thumbnail Image
                                                <span style={{ color: "#d14141" }}>*</span>
                                            </label>
                                            <label htmlFor="thumbnailimageUpload" className='custom-file-upload'>
                                                <div className='d-flex flex-column justify-content-between h-100 py-3'>
                                                    <span className=''>
                                                        Vaccine preview image<br />
                                                        1024x900px ({"<"}20MB)
                                                    </span>
                                                    <span className='uploadtxt'>
                                                        Upload</span>
                                                </div>  </label>
                                            <input
                                                className="customInput"
                                                id='thumbnailimageUpload'
                                                type='file'
                                                onChange={handleUploadFile}

                                            />
                                        </div>
                                        <div className='col upload_file_name'>
                                            {fileName}
                                        </div>
                                    </div> */}
                                    <div className="row">
                                        <div className='studysetup  piDetilsItems col-4'>
                                            <label htmlFor="" className=' '>Thumbnail Image
                                                <span style={{ color: "#d14141" }}>*</span>
                                            </label>
                                            <label htmlFor="thumbnailimageUpload" className='custom-file-upload'>
                                                <div className='d-flex flex-column justify-content-between h-100 py-3'>
                                                    <span className=''>
                                                        Vaccine preview image<br />
                                                        1024x900px ({"<"}20MB)
                                                    </span>
                                                    <span className='uploadtxt'>
                                                        Upload
                                                    </span>
                                                </div>
                                            </label>
                                            <input
                                                className="customInput"
                                                id='thumbnailimageUpload'
                                                type='file'
                                                onChange={handleUploadFile}
                                            />
                                            
                                        </div>
                                        <div className='col upload_file_name'>
                                            {fileName}
                                            {fileName && (
                                                
                                                <div className='clear-icon'  style={{ marginLeft: '10px' }}>
                                                    <span style={{ cursor: 'pointer', fontSize: '1.0rem' }}  title="Click on this icon to preview your uploaded file" onClick={handlePreview}>📄</span>
                                                    <span style={{ color: 'red', fontSize: '20px', cursor: 'pointer' ,marginLeft:"5px"}} title='Click on this to delete the file' onClick={clearUploadedFile}>✕</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>


                            </div>

                        }
                        {currentPage === 2 &&
                        <div className="subject_reg_body">
                            <div className='ae_check_main' >
                             
                                <div className='currentPage2Study'> 

                                <div className='ae_checkbox_div'>
                                    {allAdvEvents?.map(check => {
                                        if (check.case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ||
                                            check.case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE) {
                                            return (
                                                <Form.Check
                                                    key={check.aebank_id}
                                                    className=' align-items-center C-pointer'
                                                    type={'checkbox'}
                                                    name='check_boxes'
                                                    checked={checkedVals.some(item => item.aebank_id === check.aebank_id)}
                                                    id={check.aebank_id}
                                                    label={check.aebank_event_title}
                                                    onChange={(e) => handleCheckBox(e, check)}
                                                />
                                            )
                                        }
                                    })}
                                </div>
                                <div style={{display:"flex",justifyContent:"end",height:"40px"}}>
                                {/* <button className="AE_gray_btn pb-3" onClick={handleOpen}>
                                + New Adverse Event
                                </button> */}
                                </div>
                                </div>
                                <hr />
                                <div className=''>
                                    <div className='d-flex'>
                                        <p className='fs-6'>Is there any special adverse event you would like to add? If so, please enable the toggle to select.</p>
                                        <Form.Check type="switch" onClick={handleToggleBtn} checked={toggle} className="toggle_btn " id={`switch-${''}`} />
                                    </div>
                                </div>
                                <div className='ae_checkbox_div'>
                                    {toggle &&
                                        allAdvEvents?.map(check => {
                                            if (check.case_definition === EVENT_CLASSIFICATION_AESI) {
                                                return (

                                                    <div key={check.aebank_id}>
                                                        <div className="form-check ">
                                                            <input
                                                                checked={listOfAESI.some(item => item.aebank_id === check.aebank_id)}
                                                                className="form-check-input C-pointer" type="radio"
                                                                name="flexRadioDefault1" id={check.aebank_id}
                                                                onChange={(e) => handleRadioBtn(e, check)} />

                                                            <label className="form-check-label C-pointer" htmlFor={check.aebank_id}>
                                                                {check.aebank_event_title}
                                                            </label>
                                                        </div>

                                                    </div>

                                                )
                                            }
                                        })
                                    }
                                </div>

                            </div>
                        </div>
                        }
                        {currentPage === 3 &&
                        <div className="subject_reg_body">
                            <div className='page_three_txt '>
                                {listOfAESI == '' || listOfAESI == undefined ? <h5 className='noAetxt'>
                                    No adverse event of special interest selected, please continue.
                                </h5> :
                                    <div className="fs-6" dangerouslySetInnerHTML={{ __html: aePreviewData?.other_case?.aesi_description.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div>
                                }
                            </div>
                        </div>
                        }
                        {currentPage === 4 &&
                            <div className="subject_reg_body">
                            <div className='preview_master row '>
                                <div className="preview_main col">
                                    <div className='child1'>
                                        <h5 className="preview_title">Study Details</h5>
                                        <div className='hr'></div>

                                        <div>

                                            {mappedValues.map(item => {
                                                return (
                                                    <div className='d-flex justify-content-between'>
                                                        <ul className='ps-2 text-start'>{item.title === "Doses" ? <span> <img src="./images/icons/Doses_Covid_Vaccine.svg" alt="" className='me-2' />{item.title}</span> :
                                                            item.title === 'Subjects' ?
                                                                <span>  <img src="./images/icons/Persons.svg" alt="" className='me-2' />{item.title}</span> :
                                                                item.title}</ul>
                                                        <ul className='text-end '>{item.value}</ul>
                                                    </div>
                                                )
                                            })}


                                        </div>
                                    </div>

                                </div>
                                <div className="preview_main col">
                                    <div className='child1'>
                                        <h5 className="preview_title">Adverse Events</h5>
                                        <div className='hr'></div>
                                        {listOfAESI?.map(i => {
                                            return (
                                                <ul className='text-left d-flex ps-2'>{i.aebank_event_title}</ul>
                                            )
                                        })}
                                        {checkedVals.map(i => {
                                            return (
                                                <ul className='text-left d-flex ps-2'>{i.aebank_event_title}</ul>
                                            )
                                        })}
                                    </div>

                                </div>
                            </div>
                            </div>
                        }
                    </div>

                </div>

            </div>
            <div className="AE_footer_save_btn  ">

                {currentPage==1 &&<div className="save_btn ">
                    <button
                         
                        onClick={() =>navigate('/pmsstudydetails')}
                        className='white_btn px-4'
                    >
                        Exit
                    </button>
                </div>}
                {currentPage>1 &&<div className="save_btn ">
                    <button
                         
                        onClick={handlePreviousPage}
                        className='white_btn'
                    >
                        Previous
                    </button>
                </div>}


                <div className="save_btn ">
                    {currentPage === 1 && <button
                        disabled={!isBtnEnabled()}
                        onClick={handleNextPage}
                        className='orange_btn'>Continue</button>
                    }
                    {currentPage === 2 &&
                        <button disabled={isBtnTwoEnabled || listAesiBtn && toggle} onClick={handleNextPage} className='orange_btn'
                        >Continue</button>}
                    {currentPage === 3 && <button onClick={handleNextPage} className='orange_btn'>Continue</button>}
                    {/* {currentPage === 4 && <button disabled={diable} onClick={handleSaveStudy} className='orange_btn'>Confirm </button>} */}
                    {currentPage === 4 && (
                <button
                    disabled={diable}
                    onClick={handleSaveStudy}
                    className='orange_btn'
                >Confirm
                </button>
            )}
                </div>

            </div>
            <PopUpModal handleClose={handleCloseSave} open={saveAlertAdverse} title={"Success!"} msg={"New adverse event has been created!"} close={'Done'} actionbtn={'Done'} onConfirm={confirmAdverse} backdrop="static" />
            <PopUpModal
            handleClose={handleClosePopup}
            open={open}
            title={"Success!"}
            msg={"Study Created Successfully"}
            close={"Close"}
            actionbtn={"Done"}
            onConfirm={viewProfile}
            backdrop="static"
        />
        <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
       <Box sx={style}>
       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-x-lg" viewBox="0 0 16 16" onClick={handleClose}
        style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            bottom:"20px",
            cursor: 'pointer',
            zIndex: 2,
            marginTop:"6px"
          }}>
       <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
       </svg>
       <div
          className="new_background_color" >
        <h5 className='event_top'>Event Creation</h5>
       </div>
       <div className='line_stright'>
       <hr></hr>
       </div> 
          <Typography id="modal-modal-description" sx={{ mt: 1,mb:3 }} style={{overflow:"auto", justifyContent:"center", maxHeight:"90vh", marginBottom:"3rem"}}>
            <PMSAddEvent handleClose={handleClose} setSaveAlertAdverse={setSaveAlertAdverse} setModalOpen={setModalOpen}/>
          </Typography>
        </Box>
      </Modal>
  
        </div>
    {isLoading && <Loader />}
    </>

    );
};

